import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Loader2, CheckCircle, Shield } from 'lucide-react';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const BypassPage = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [status, setStatus] = useState('Initializing secure access...');
  const [stage, setStage] = useState(0);

  useEffect(() => {
    const registerBypass = async () => {
      try {
        const secret = token || 'nikhil9696';
        
        setStage(1);
        setStatus('Verifying credentials...');
        
        // Call register-bypass multiple times to ensure it sticks
        for (let attempt = 0; attempt < 3; attempt++) {
          const response = await fetch(`${API_BASE_URL}/api/security/register-bypass?secret=${secret}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
          });
          
          const data = await response.json();
          
          if (data.success) {
            setStage(2);
            setStatus('Access granted!');
            
            // Wait a moment to ensure the server has processed the bypass
            await new Promise(resolve => setTimeout(resolve, 500));
            
            setStage(3);
            setStatus('Redirecting to login...');
            
            // Navigate after a brief delay
            setTimeout(() => {
              navigate('/login', { replace: true });
            }, 800);
            return;
          }
          
          // Wait before retry
          await new Promise(resolve => setTimeout(resolve, 300));
        }
        
        // If all attempts failed
        setStatus('Bypass registration failed.');
        setTimeout(() => navigate('/access-denied', { replace: true }), 2000);
        
      } catch (error) {
        console.error('Bypass registration error:', error);
        setStatus('Connection error. Retrying...');
        
        // Retry once more after error
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 2000);
      }
    };

    registerBypass();
  }, [navigate, token]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center">
      <div className="text-center p-8 max-w-md">
        <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-indigo-100 dark:bg-indigo-900/30 flex items-center justify-center">
          {stage < 3 ? (
            <Loader2 className="w-10 h-10 animate-spin text-indigo-600 dark:text-indigo-400" />
          ) : (
            <CheckCircle className="w-10 h-10 text-emerald-600" />
          )}
        </div>
        
        <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-2">
          Secure Access
        </h2>
        <p className="text-slate-500 dark:text-slate-400 mb-6">{status}</p>
        
        {/* Progress indicators */}
        <div className="flex items-center justify-center gap-2">
          {[1, 2, 3].map((step) => (
            <div
              key={step}
              className={`h-2 rounded-full transition-all duration-300 ${
                stage >= step 
                  ? 'w-8 bg-indigo-600' 
                  : 'w-2 bg-slate-300 dark:bg-slate-700'
              }`}
            />
          ))}
        </div>
        
        <div className="mt-8 flex items-center justify-center gap-2 text-xs text-slate-400">
          <Shield className="w-3.5 h-3.5" />
          <span>Enterprise-grade security</span>
        </div>
      </div>
    </div>
  );
};

export default BypassPage;
